import React, { useEffect } from 'react';

import FinalProductView from './FinalProductView';
import WithLoading from '../../../Hoc/WithLoading';

export const FinalProductUrl = `/final-product/request/:id`;

const FinalProduct = ({ id }) => {
  useEffect(() => {}, [id]);
  return (
    <WithLoading
      component={FinalProductView}
      url={FinalProductUrl.replace(':id', id)}
      onlyLoader
      padding="6rem"
    />
  );
};

export default React.memo(FinalProduct);
